// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"styles_Wrapper__07r39","Message":"styles_Message__XD_nj","Button":"styles_Button__aG4tf","ButtonText":"styles_ButtonText__aM4F_"};